import { Button } from "@material-ui/core";
import currency from "currency.js";

const Amount = ({ amount, currency: Currency, setData }) => {
  const VES = (value) =>
    currency(value, { symbol: "", decimal: ",", separator: "." });

  return (
    <div className="d-flex flex-column">
      <h3 className="text-center">Resumen</h3>
      <span className="my-2">
        Su saldo es:{" "}
        <strong>
          {VES(amount).format()} {Currency}
        </strong>
      </span>
      <Button variant="contained" color="primary" onClick={() => setData(null)}>
        Atrás
      </Button>
    </div>
  );
};

export default Amount;
